import get from "lodash/get";
import assign from "lodash/assign";
import * as TYPES from "../../constants/actionTypes";
import { userFilter } from "../../constants/filterTypes";

const initialState = assign({}, { ...userFilter });

const userFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.USER_FILTER:
      return {
        ...state,
        ...get(action, "payload", {}),
      };

    case TYPES.CLEAR_USER_FILTER:
      return assign({}, { ...userFilter });

    default:
      return state;
  }
};

export default userFilterReducer;
